import Vue from 'vue';
import trackClickEvent from './analytics-event.directive';
import translatedProperty from './translated-property.directive';

Vue.directive('track-click', trackClickEvent);
Vue.directive('translated-property', translatedProperty);
